export const getDomain = () => {
  const url = window.location.origin;
  if (url.endsWith('localhost:4000') || url.endsWith('localhost:3000')) {
    return 'localhost';
  }
  if (url.endsWith('ai-hayden-staticweb.s3-us-west-2.amazonaws.com')) {
    return 'ai-hayden-staticweb.s3-us-west-2.amazonaws.com';
  }
  if (url.endsWith('ai-hayden-staticweb.s3-website-us-west-2.amazonaws.com')) {
    return 'ai-hayden-staticweb.s3-website-us-west-2.amazonaws.com';
  }

  if (url.endsWith('staging.console.hayden.ai')) {
    return 'staging.console.hayden.ai';
  }

  if (url.endsWith('beta.console.hayden.ai')) {
    return 'beta.console.hayden.ai';
  }

  if (url.endsWith('eupilot.console.hayden.ai')) {
    return 'eupilot.console.hayden.ai';
  }
  return 'hayden.ai';
};
